// PrehladMobile — PREHĽAD pre vedenie v mview (STAVBA_HISTORIA_V1, Mirko 21. 10. 2026, ksbx-appky 2675/2677: „pre mňa ja by som mal mať viac“).
// Presne podľa schválených screenshotov MATRIX Stavba 1.3 (13) (ksbx-appky 2689: „Schvaľujem Prehľad a Stavby podľa screenshotov 1.3 (13)“):
// Môj deň · štyri dlaždice · Chýba · Leje sa a rozrobené protokoly · Kto kde je podľa Rozpisu a dochádzky · Hlásenia a SMS zo stavieb.
// Zdroj: GET /api/mobile/prehlad (dochádzka, Rozpis, poter_protokoly, notifications) — telefón nič nepočíta.
import React, { useEffect, useState } from 'react'
import { M, S } from './mockupTheme.js'
import { fetchAuth } from '../auth/fetchAuth.js'

export default function PrehladMobile({ onMojDen, onOtvorProtokol, onOtvorStavbu }) {
  const [d, setD] = useState(null); const [chyba, setChyba] = useState('')
  const nacitaj = async () => {
    try { const r = await fetchAuth('/api/mobile/prehlad'); const j = await r.json().catch(() => ({})); if (!r.ok) throw new Error(j.error || 'Chyba ' + r.status); setD(j); setChyba('') }
    catch (e) { setChyba(navigator.onLine ? e.message : 'Bez signálu — Prehľad sa načíta, keď bude signál.') }
  }
  useEffect(() => { nacitaj(); const t = setInterval(nacitaj, 60000); return () => clearInterval(t) }, [])

  const dl = (d && d.dlazdice) || {}
  const Dlazdica = ({ v, n, farba }) => <div style={{ flex: 1, minWidth: 0, background: M.card, borderRadius: 12, padding: 12 }}>
    <div style={{ fontSize: 24, fontWeight: 800, color: farba }}>{v == null ? '—' : v}</div><div style={{ fontSize: 12, color: M.mut, lineHeight: 1.25 }}>{n}</div></div>
  const Karta = ({ nadpis, children }) => <div style={S.karta}><div style={S.nadpis}>{nadpis}</div>{children}</div>
  const md = d && d.moj_den

  return <div style={S.stranka}>
    <div style={S.h1}>Prehľad</div>
    <p style={S.sub}>{d ? d.den_text : ''} · všetky stavby</p>
    {chyba && <div style={{ ...S.hint, color: M.red }}>{chyba}</div>}
    {d === null && !chyba && <div style={S.hint}>Načítavam…</div>}
    {/* môj deň — Mirko sám chodí na stavbu: Príchod, Pokládka, anhydrit */}
    <div role="button" onClick={onMojDen} style={{ display: 'flex', alignItems: 'center', background: M.card, borderRadius: 14, padding: 14, marginBottom: 12, cursor: 'pointer' }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 17, fontWeight: 700 }}>Môj deň</div>
        <div style={{ fontSize: 13, color: M.mut }}>{md && md.na_stavbe ? 'Si na stavbe · ' + (md.project_name || md.nazov) + ' · príchod ' + md.prichod : 'Príchod, Pokládka a anhydrit na mojej stavbe'}</div>
      </div>
      <span style={{ color: M.mut, fontSize: 22 }}>›</span>
    </div>
    <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
      <Dlazdica v={dl.na_stavbe} n="na stavbe teraz" farba={M.ac} />
      <Dlazdica v={dl.v_rozpise} n="v Rozpise dnes" farba={M.ac} />
      <Dlazdica v={dl.rozrobene} n="rozrobené protokoly" farba={M.amb} />
      <Dlazdica v={dl.caka_podpis} n="čaká podpis" farba={dl.caka_podpis ? M.red : M.mut} />
    </div>
    {d && d.chyba.length > 0 && <Karta nadpis="Chýba">{d.chyba.map((c, i) => <div key={i} style={{ fontSize: 15, color: M.red, lineHeight: 1.35, marginBottom: 6 }}>{c.text}</div>)}</Karta>}
    {d && d.rozrobene.length > 0 && <Karta nadpis="Leje sa a rozrobené protokoly">{d.rozrobene.map(x => (
      <div key={x.id} role={x.mozem_pokracovat ? 'button' : undefined} onClick={() => x.mozem_pokracovat && onOtvorProtokol && onOtvorProtokol(x)} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 0', borderBottom: `1px solid ${M.line}`, cursor: x.mozem_pokracovat ? 'pointer' : 'default' }}>   {/* PROTOKOL_CEMENT_MVIEW_V1 */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 15, fontWeight: 600 }}>{x.nazov_stavby}</div>
          <div style={{ fontSize: 13, color: M.mut }}>{x.id} · {x.miesto} · {x.stav_text} · {x.created_by}</div>
          {!x.mozem_pokracovat && x.pokracovat_text && <div style={{ fontSize: 13, color: M.mut }}>{x.pokracovat_text}</div>}
        </div>
        {x.mozem_pokracovat ? <span style={{ color: M.ac, fontWeight: 700, fontSize: 15 }}>Otvoriť</span> : null}
      </div>))}</Karta>}
    <Karta nadpis="Kto kde je · podľa Rozpisu a dochádzky">
      {d && !d.stavby.length && <div style={{ fontSize: 15, color: M.mut }}>Dnes nikto v Rozpise ani na stavbe.</div>}
      {d && d.stavby.map(st => (
        <div key={st.project_id} style={{ padding: '8px 0', borderBottom: `1px solid ${M.line}` }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
            <span role="button" onClick={() => onOtvorStavbu && onOtvorStavbu(st.project_id)} style={{ flex: 1, fontSize: 15, fontWeight: 700, cursor: 'pointer' }}>{st.nazov}</span>
            {st.leje_sa ? <span style={{ fontSize: 13, fontWeight: 700, color: M.amb }}>leje sa</span> : null}
          </div>
          {st.prichody.map((a, i) => <div key={i} style={{ fontSize: 13, color: a.na_stavbe ? M.grn : M.mut }}>● {a.meno} · {a.start_at}{a.na_stavbe ? ' → na stavbe' : ' – ' + a.end_at}</div>)}
          {st.bez_prichodu.length > 0 && <div style={{ fontSize: 13, color: M.mut }}>○ v Rozpise, bez príchodu: {st.bez_prichodu.map(b => b.meno).join(', ')}</div>}
        </div>))}
    </Karta>
    {d && d.hlasenia.length > 0 && <Karta nadpis="Hlásenia a SMS zo stavieb">{d.hlasenia.slice(0, 10).map(n => (
      <div key={n.id} style={{ padding: '6px 0', borderBottom: `1px solid ${M.line}` }}>
        <div style={{ fontSize: 15, fontWeight: 600 }}>{n.titul}</div>
        {n.sprava && <div style={{ fontSize: 13, color: M.mut }}>{n.sprava}</div>}
        <div style={{ fontSize: 12, color: M.mut }}>{n.kedy_text}{n.kto ? ' · ' + n.kto : ''}</div>
      </div>))}</Karta>}
  </div>
}
